import firebase from "firebase/compat/app";
import IDonation from "../types/services/IDonation";
import { nodeForPostType } from "./helpers";

function viewSparkTitleFromPost(post: { title?: string } | null): string {
  const title = post && post.title != null ? String(post.title).trim() : "";
  return title || "Untitled post";
}

export function trackingPostIdOf(donation: IDonation): string {
  const raw = donation.trackingPostId;
  if (!raw) {
    return "";
  }
  const trimmed = raw.trim();
  return trimmed;
}

export async function lookupViewSparkLabel(
  charityId: string,
  postId: string
): Promise<string> {
  try {
    const published = await firebase
      .database()
      .ref(`${charityId}/${nodeForPostType("published")}/${postId}`)
      .once("value");
    if (published.exists()) {
      return viewSparkTitleFromPost(published.val());
    }
    const pending = await firebase
      .database()
      .ref(`${charityId}/${nodeForPostType("pending")}/${postId}`)
      .once("value");
    if (pending.exists()) {
      return viewSparkTitleFromPost(pending.val());
    }
    return "Deleted post";
  } catch (error) {
    return "";
  }
}
